import { retrieveLegacyIdConfig } from "./legacyConfig.datasource";
import { LegacyIdConfigParams } from "./legacyConfig.shemas";

export async function getLegacyIdConfig(params: LegacyIdConfigParams) {
    try {
        const response = (await retrieveLegacyIdConfig(params)).data;

        return response;
    } catch (error) {
        throw error;
    }
}